import React, {useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import { Button, Popup, Icon, Input } from 'semantic-ui-react';
import { ReactHTMLConverter } from 'react-html-converter/browser';
import HtmlEditorPopup from '../HtmlEditor';

const html = new ReactHTMLConverter();
const HTML_EMPTY_STRING = "<p><br></p>";

const TextInputWithHtmlEditor = ({
    header,
    value: propValue,
    disabled: propDisabled,
    onBlur,
    maxLength
}) => {
    const [text, setText] = useState(propValue);
    const [openEditor, setOpenEditor] = useState(false);

    useEffect(() => {
        setText(propValue);
    }, [propValue]);

    const handleChange = useCallback((e, { value }) => {
        setText(value);
    });

    const handleBlur = useCallback(() => {
        onBlur?.(text);
        setText(text);
    }, [text]);

    const handleOpenEditor = useCallback(() => {
        setOpenEditor(true);
    }, []);

    const handleCloseEditor = useCallback(() => {
        setOpenEditor(false);
    }, []);

    const handleSaveEditor = useCallback((value) => {
        handleCloseEditor();
        const newValue = value && value !== HTML_EMPTY_STRING ? value : "";
        setText(newValue);
        onBlur?.(newValue);
    }, []);

    return (
        <>
            <Input
                type='text'
                action
                fluid
                disabled={propDisabled}
                placeholder={header}
                value={text}
                maxLength={maxLength}
                onBlur={handleBlur}
                onChange={handleChange}
            >
                <input />
                <Popup
                    trigger={(
                    <Button
                        icon
                        disabled={propDisabled || !text}
                    >
                        <Icon name="eye" />
                        </Button>
                    )}
                    flowing
                    disabled={propDisabled || !text}
                    on="click"
                >
                    <Popup.Content>
                        {html.convert(text)}
                    </Popup.Content>
                </Popup>
                <Button
                    icon
                    disabled={propDisabled}
                    onClick={handleOpenEditor}
                >
                    <Icon name="edit" />
                </Button>
            </Input>
            <HtmlEditorPopup
                title={header}
                value={text}
                startOpen={openEditor}
                onCancel={handleCloseEditor}
                onSave={handleSaveEditor}
                maxLength={maxLength}
            />
        </>
    );
};

TextInputWithHtmlEditor.propTypes = {
    header: PropTypes.string.isRequired,
    value: PropTypes.string,
    disabled: PropTypes.boolean,
    onBlur: PropTypes.func,
    maxLength: PropTypes.number
};

export default TextInputWithHtmlEditor;
